import { NavLink } from "react-router-dom";
import { useAuth } from "react-oidc-context";

const linkClasses = ({ isActive }: { isActive: boolean }) =>
  `text-sm font-medium px-3 py-2 rounded-md transition ${
    isActive ? "text-ink-900 bg-ink-100" : "text-ink-500 hover:text-ink-900"
  }`;

export default function NavBar() {
  const auth = useAuth();
  const email = auth.user?.profile.email as string | undefined;

  return (
    <header className="border-b border-ink-200 bg-white">
      <div className="mx-auto flex max-w-page items-center justify-between px-6 py-4">
        <div className="flex items-center gap-8">
          <div className="text-base font-semibold tracking-tight">
            Accuryn <span className="text-ink-500">Sales</span>
          </div>
          <nav className="flex items-center gap-1">
            <NavLink to="/" end className={linkClasses}>
              Overview
            </NavLink>
            <NavLink to="/segmentation" className={linkClasses}>
              Customers
            </NavLink>
            <NavLink to="/map" className={linkClasses}>
              Map
            </NavLink>
            <NavLink to="/yearly" className={linkClasses}>
              Year over Year
            </NavLink>
            <NavLink to="/actions" className={linkClasses}>
              Actions
            </NavLink>
            <NavLink to="/silent" className={linkClasses}>
              Silent
            </NavLink>
            <NavLink to="/va-govt" className={linkClasses}>
              VA / Govt
            </NavLink>
            <NavLink to="/hospital-units" className={linkClasses}>
              Accuryn Units
            </NavLink>
            <NavLink to="/reports" className={linkClasses}>
              Reports
            </NavLink>
          </nav>
        </div>
        <div className="flex items-center gap-3">
          {email && <span className="text-sm text-ink-500">{email}</span>}
          <button
            type="button"
            className="btn-ghost"
            onClick={() => auth.signoutRedirect()}
          >
            Sign out
          </button>
        </div>
      </div>
    </header>
  );
}
